<template lang="pug">
k-page.post.contact( :key='postData.id' )
  d-main-image( v-bind=`{ img, show }` @load='pageLoaded' )
  w-go-down
  k-main( :title='title' )
    template( v-if='postData')
      .content( v-html='postContent' )
    no-post( v-else )
</template>

<script lang="js">
import routeEvents from '@/lib/route-events'
import KPage from '@/blocks/k-page'
import KMain from '@/blocks/k-main'
import DMainImage from '@/displays/d-main-image'
import WGoDown from '@/widgets/w-go-down'
import NoPost from '@/components/no-post'
import { Page } from '@/mixins'

export default {
  name: 'Page',
  mixins: [ Page ],
  components: { NoPost, KPage, KMain, DMainImage, WGoDown },
  props: {},
  data() {
    return {
    }
  },
  beforeRouteUpdate: routeEvents.toPath,
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.page {

}
</style>
